'use strict';

class AuthLoginController {
    /*@ngInject*/
    constructor ($mdDialog, auth, utils, orderStore, $stateParams,$interval, $localStorage, $scope) {
        "ngInject";
        this.$mdDialog = $mdDialog;
        this.auth = auth;
        this.utils = utils;
        this.user = {};
        this.orderStore = orderStore;
        this.$stateParams = $stateParams;
        this.$localStorage = $localStorage;
        this.$scope = $scope;
        this.$interval = $interval;
        $scope.conutdownTexthide = false;
        $scope.tpinBtnHide = true;

        var decreamentCountdown=function()
        {
            $scope.tpinBtnHide = true;
            $scope.conutdownTexthide = false;

            $scope.countdown -=1;
            if($scope.countdown<1)
            {
                $scope.tpinBtnHide = false;
                $scope.conutdownTexthide = true;
            }
        };
        $scope.startCountDown=function()
        {
            $interval(decreamentCountdown,1000,$scope.countdown)
        };
        $scope.countdown=15;
    }

    checkIfValidForm(form) {

        // Set form as submitted
        form.$setSubmitted();

        return form.$valid;
    }
    enterKey(keyEvent) {
        if (keyEvent.which == 13 || keyEvent.keyCode == 13) {
            this.generateTpin();
        }
    }
    entertpinKey(keyEvent) {
        if (keyEvent.which == 13 || keyEvent.keyCode == 13) {
            this.login();
        }
    }
    
    cancel () {
        this.$mdDialog.cancel();
    }

    requestTPin() {
        this.$scope.countdown = 15;
        this.$scope.startCountDown();
        this.$scope.tpinBtnHide = true;
        this.$scope.conutdownTexthide = false;
        let deferred = this.auth.createUser(this.user, false)
            .then(
                (response) => {
                    this.enterTpin = true;
                    this.user = response;
                },
                (error) => console.log(error)
            );

        this.utils.busyDeferred(this, deferred, '__busy');

        return false;
    }


    generateTpin() {
        const isValidForm = this.checkIfValidForm(this.numberForm);
        this.$scope.startCountDown();
        if (!isValidForm) {
            return false;
        }

        let deferred = this.auth.createUser(this.user, false)
            .then(
                (response) => {
                    this.enterTpin = true;
                    this.user = response;
            },
            (error) => console.log(error)
        );

        this.utils.busyDeferred(this, deferred, '__busy');

        return false;
    }

    login() {
        const isValidForm = this.checkIfValidForm(this.tpinForm);
        if (!isValidForm) {
            return false;
        }

        if(!this.user.password){
            return false;
        }

        let deferred = this.auth.login(this.user.password, this.user.phone_number)
            .then(
                (user) => {
                    this.proceed();
                },
                (error) => {
                    console.log(error);
                    alert("Invalid Tpin!");
                }
            );

        this.utils.busyDeferred(this, deferred, '__busy');
    }

    proceed () {
        this.$mdDialog.hide();
    }
}

export default AuthLoginController;


// WEBPACK FOOTER //
// ./client/app/common/auth/modals/auth.loginNumber.controller.js